import { useDocumentPdfFile } from '~/entities/document'
import { PDFDocument } from '~/shared/ui'

export function ReviewPdf({ documentKey }: { documentKey: string }) {
  const { file, isLoading } = useDocumentPdfFile(documentKey)

  return (
    <PDFDocument
      file={file}
      isLoading={isLoading}
      initialFitToWidth
      onOpenInNewTab={() =>
        window.open(`/documents/${encodeURIComponent(documentKey)}/view-pdf`, '_blank')
      }
    />
  )
}
